import { CornerRadiusComponent, Entity } from '@aninix-inc/model'
import { INode } from 'svgson'

export const applyCornerRadius = (entity: Entity, node: INode) => {
  const cornerRadius = parseFloat(node.attributes.rx)
  if (!cornerRadius) return

  entity.updateComponent(CornerRadiusComponent, cornerRadius)
}
